import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=481ca44c&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('481ca44c')) {
      api.createRecord('481ca44c', component.options)
    } else {
      api.reload('481ca44c', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=481ca44c&", function () {
      api.rerender('481ca44c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bcd0yu2ryi1i/JS/pricehelp.vue"
export default component.exports